module.exports = __webpack_public_path__ + "static/media/AgLeaderBlue.bcfb5bcc.png";